import styled from 'styled-components'

const StyledCreateInstagramPostType = styled.div`
  .post-type-buttons {
    margin-top: 8px;
    display: flex;
    gap: 8px;

    button {
      flex: 1;
      height: 40px;
      border-radius: 8px;
      box-shadow: inset 0 0 0 1.25px ${({ theme }) => theme.color.gray[300]};
      background-color: transparent;
      font-weight: 500;
      font-size: 14px;
      color: ${({ theme }) => theme.color.gray[500]};
      transition: 0.2s;

      &.active {
        box-shadow: inset 0 0 0 1.5px ${({ theme }) => theme.color.brand};
        color: ${({ theme }) => theme.color.brand};
        background-color: ${({ theme }) => `${theme.color.brand}10`};
      }
    }
  }
`

export default StyledCreateInstagramPostType
